export default __webpack_public_path__ + "static/media/icon-too-sad-face-full.15f81d41.svg";